import { IssueRecord } from '@/entities/issue/v2';

export interface InformationBoxProps {
  issue: IssueRecord;
}

export const informationBoxProps = ['issue'];
